import { produce } from 'immer';

import { SaveImportExportWizard } from '../../actions/importExportWizard/saveImportExportWizard';
import { ImportExportWizardState, ImportExportWizardStatus } from '../../typings/importExportWizard';

export function saveImportExportWizard(
    state: ImportExportWizardState,
    action: SaveImportExportWizard
): ImportExportWizardState {
    return produce(state, draft => {
        draft.status = ImportExportWizardStatus.SAVING;
    });
}
